import { IContainer, ILazyBinder, injectContainer } from './container';

export enum IBrowserPlatform {
    Unknown = 0,
    MobileiOS = 1,
    MobileAndroid = 2,
}

export interface IBrowser {
    platform: IBrowserPlatform;
    isMobile: boolean;
    isInstalled: boolean;
}

const TYPES = {
    IBrowser: Symbol.for('IBrowser'),
};

export function injectBrowser(container: IContainer = injectContainer()): Promise<IBrowser> {
    return container.get<ILazyBinder<IBrowser>>(TYPES.IBrowser)();
}

export function bindBrowser(val: ILazyBinder<IBrowser>, container: IContainer = injectContainer()) {
    return container.bind<ILazyBinder<IBrowser>>(TYPES.IBrowser, val);
}
